import {
    GET_MEMBERSHIPPACKAGES_INFO_LOADING, MEMBERSHIPPACKAGES_DATA_SUCCESS,
    MEMBERSHIPPACKAGES_DATA_ERROR, MEMBERSHIPPACKAGES_DATA_RESET, GET_MEMBERSHIPPACKAGE_OBJECT,
    UPDATE_MEMBERSHIPPACKAGE, DELETE_MEMBERSHIPTYPEPERSON, UPDATE_MEMBERSHIPADDONS_QUANTITY, UPDATE_PACKAGE_FOR_RENEW,
    UPDATE_FAMILYMEMBERS_NOT_PART_OF_PACKAGE, MEMBERSHIPPACKAGE_DATA_RESET, UPDATE_PACKAGE_FOR_RENEW_TO_NEW_MEMBERSHIPPACKAGE
} from "../actions/actionMembershipPackages";

import { genfunction } from 'helpers';
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey1 = "membershipPackage";
const sessionKey2 = "familymembersnotpartofPackage";
const sessionKey3 = "membershipPackages";


const initialState = {
    membershippackages: loadState(sessionKey3, []),
    membershipPackage: loadState(sessionKey1, {}),
    loading: false,
    membershippackagesError: '',
    familymembersnotpartofPackage: loadState(sessionKey2, [])
};

function reducerMembershipPackages(state = initialState, action) {

    switch (action.type) {
        case GET_MEMBERSHIPPACKAGES_INFO_LOADING: {
            return {
                ...state,
                loading: true,
                membershippackagesError: ''
            };
        }

        case MEMBERSHIPPACKAGES_DATA_SUCCESS: {

            saveState(sessionKey3, action.payload);

            return {
                ...state,
                loading: false,
                membershippackages: action.payload,
                membershippackagesError: ''
            };
        }

        case GET_MEMBERSHIPPACKAGE_OBJECT: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = { ...mempackages.filter(x => x.MembershipPackageID == action.payload.memberpackID)[0] };

            if (memPackage && memPackage.hasOwnProperty("MembershipProducts")) {

                memPackage.MembershipProducts = memPackage.MembershipProducts.map(e => {

                    if (e.MembershipType === "Membership") {

                        if (e.hasOwnProperty("Users") == false) {
                            e.Users = []
                        }

                    }
                    else if (e.MembershipType === "AddOn" && !e.hasOwnProperty("Quantity")) {
                        e.Quantity = 0;
                    }

                    return e;
                });

                let packID = action.payload.membershipPackageDetails === undefined ? action.payload.memberpackID : action.payload.membershipPackageDetails.MembershipPackageID;


                if (mempackages && mempackages.length === 0) {
                    mempackages.push(memPackage);
                }
                else {
                    let packageIndexId = mempackages.findIndex(x => x.MembershipPackageID === packID);
                    mempackages[packageIndexId] = memPackage;

                }

            }

            saveState(sessionKey1, memPackage);
            saveState(sessionKey3, mempackages);

            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                membershippackagesError: ''
            }
        }

        case UPDATE_MEMBERSHIPPACKAGE: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = action.payload.isEdit ? action.payload.membershipPackageDetails : { ...mempackages.filter(x => x.MembershipPackageID == action.payload.membershipPackageDetails.MembershipPackageID)[0] };

            memPackage.MembershipProducts = memPackage.MembershipProducts.map(e => {

                if (e.MembershipType === "Membership" && action.payload.membershipPackageDetails.isEdit && e.Users) {
                    e.Users = e.Users.filter(x => x.userNo != action.payload.membershipPackageDetails.userNo);
                }

                if (e.MembershipType === "Membership" && e.MembershipTypeID == action.payload.membershipPackageDetails.membershipTypeID) {

                    var user = {
                        isPrimaryMember: action.payload.membershipPackageDetails.isPrimaryMember,
                        firstName: action.payload.membershipPackageDetails.firstName,
                        lastName: action.payload.membershipPackageDetails.lastName,
                        email: action.payload.membershipPackageDetails.email,
                        dob: action.payload.membershipPackageDetails.dob,
                        phone: action.payload.membershipPackageDetails.phone,
                        address1: action.payload.membershipPackageDetails.address1,
                        address2: action.payload.membershipPackageDetails.address2,
                        city: action.payload.membershipPackageDetails.city,
                        state: action.payload.membershipPackageDetails.state,
                        zipcode: action.payload.membershipPackageDetails.zipcode,
                        country: action.payload.membershipPackageDetails.country,
                        userNo: 0,
                        UniquePackageRef: action.payload.membershipPackageDetails.UniquePackageRef,
                        isRenewal: action.payload.membershipPackageDetails.isRenewal,
                        MembershipExpiryDate: action.payload.membershipPackageDetails.MembershipExpiryDate,
                        notPartOfPackage: action.payload.membershipPackageDetails.notPartOfPackage,
                        PreviousMembershipType: action.payload.membershipPackageDetails.PreviousMembershipType
                    }

                    if (e.hasOwnProperty("Users") == false) {
                        e.Users = []
                    }

                    if (action.payload.membershipPackageDetails.isEdit) {
                        user.userNo = action.payload.membershipPackageDetails.userNo;
                        e.Users.push(user);
                    }
                    else {
                        if (action.payload.membershipPackageDetails.userNo < 1) {
                            user.userNo = Math.floor((Math.random() * 100000) + 100000);
                            user.UDFs = [];
                        }
                        else {
                            user.userNo = action.payload.membershipPackageDetails.userNo;
                        }

                        e.Users.push(user);
                    }
                }

                return e;
            });

            if (mempackages && mempackages.length === 0) {
                mempackages.push(memPackage);
            }
            else {
                let packageIndexId = mempackages.findIndex(x => x.MembershipPackageID === action.payload.membershipPackageDetails.MembershipPackageID);
                mempackages[packageIndexId] = memPackage;
            }

            saveState(sessionKey1, memPackage);
            saveState(sessionKey3, mempackages);

            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                membershippackagesError: ''
            }


        }

        case DELETE_MEMBERSHIPTYPEPERSON: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = { ...mempackages.filter(x => x.MembershipPackageID == action.payload.MembershipPackageID)[0] };

            memPackage.MembershipProducts = memPackage.MembershipProducts.map(e => {

                if (e.MembershipType === "Membership" && e.MembershipTypeID == action.payload.membershipTypeID) {
                    e.Users = e.Users.filter(x => x.userNo != action.payload.userNo);
                }

                return e;
            });

            let packageIndexId = mempackages.findIndex(x => x.MembershipPackageID === memPackage.MembershipPackageID);
            mempackages[packageIndexId] = memPackage;

            saveState(sessionKey1, memPackage);
            saveState(sessionKey3, mempackages);

            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                membershippackagesError: ''
            }
        }

        case UPDATE_MEMBERSHIPADDONS_QUANTITY: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = { ...mempackages.filter(x => x.MembershipPackageID == action.payload.MembershipPackageID)[0] };

            memPackage.MembershipProducts = memPackage.MembershipProducts.map(e => {

                if (e.MembershipType === "AddOn" && e.MembershipTypeID == action.payload.MembershipTypeID) {
                    if (e.hasOwnProperty("Quantity") && e.Quantity == 0) {
                        e.Quantity = 1;
                    }
                    else {
                        e.Quantity = 0;
                    }

                    e.isRenewPackage = action.payload.isRenewPackage;
                }

                return e;
            });

            let packageIndexId = mempackages.findIndex(x => x.MembershipPackageID === memPackage.MembershipPackageID);
            mempackages[packageIndexId] = memPackage;

            saveState(sessionKey1, memPackage);
            saveState(sessionKey3, mempackages);

            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                membershippackagesError: ''
            }

        }
        case MEMBERSHIPPACKAGES_DATA_ERROR: {

            saveState(sessionKey1, {});
            saveState(sessionKey2, []);
            saveState(sessionKey3, []);

            return {
                ...state,
                loading: false,
                membershippackagesError: action.error,
                membershipPackage: {},
                membershippackages: [],
                familymembersnotpartofPackage: []
            }
        }

        case MEMBERSHIPPACKAGES_DATA_RESET: {

            saveState(sessionKey1, {});
            saveState(sessionKey2, []);
            saveState(sessionKey3, []);

            return {
                ...state,
                loading: false,
                membershippackagesError: '',
                familymembersnotpartofPackage: [],
                membershippackages: [],
                membershipPackage: {}
            };
        }

        case UPDATE_PACKAGE_FOR_RENEW: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = { ...mempackages.filter(x => x.MembershipPackageID == action.payload.packageID)[0] };

            var membersnotpartofPackage = { ...state.familymembersnotpartofPackage }

            if (memPackage) {

                let memberpackageDetails = genfunction.UpdateMembershipPackageForRenew(memPackage, action.payload.memberMemberships.membermerberhips[0], action.payload.customer);
                memPackage = memberpackageDetails.membershipPackage;
                membersnotpartofPackage = memberpackageDetails.userslist;

                let packageIndexId = mempackages.findIndex(x => x.MembershipPackageID === action.payload.packageID);
                mempackages[packageIndexId] = memPackage;

                saveState(sessionKey1, memPackage);
                saveState(sessionKey2, membersnotpartofPackage);
            }

            saveState(sessionKey3, mempackages);

            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                familymembersnotpartofPackage: membersnotpartofPackage,
                membershippackagesError: ''
            }
        }

        case MEMBERSHIPPACKAGE_DATA_RESET: {

            saveState(sessionKey1, {});
            saveState(sessionKey2, []);
            saveState(sessionKey3, []);

            return {
                ...state,
                membershipPackage: {},
                familymembersnotpartofPackage: []
            };

        }
        case UPDATE_FAMILYMEMBERS_NOT_PART_OF_PACKAGE: {

            var membersnotpartofPackage = [...state.familymembersnotpartofPackage];

            var member = { ...membersnotpartofPackage.filter(x => x.userNo == action.payload.userNo)[0] };

            if (action.payload.isAdded) {
                member.notpartofPackage = false;
                member.userSelectedFromDropdown = true;
            }
            else {
                member.notpartofPackage = true;
                member.userSelectedFromDropdown = false;
            }

            membersnotpartofPackage = membersnotpartofPackage.filter(x => x.userNo != action.payload.userNo);
            membersnotpartofPackage.push(member);

            saveState(sessionKey2, membersnotpartofPackage);

            return {
                ...state,
                loading: false,
                familymembersnotpartofPackage: membersnotpartofPackage,
            }
        }

        case UPDATE_PACKAGE_FOR_RENEW_TO_NEW_MEMBERSHIPPACKAGE: {

            let mempackages = JSON.parse(JSON.stringify(state.membershippackages));
            let memPackage = { ...mempackages.filter(x => x.MembershipPackageID == action.payload.packageID)[0] };

            var membersnotpartofPackage = { ...state.familymembersnotpartofPackage }

            if (memPackage) {

                let memberpackageDetails = genfunction.UpdateMembershipPackageForRenewToNewMembershipPackage(memPackage, action.payload.memberMemberships.membermerberhips[0], action.payload.customer);
                memPackage = memberpackageDetails.membershipPackage;
                membersnotpartofPackage = memberpackageDetails.userslist;

                let packageIndexId = mempackages.findIndex(x => x.MembershipPackageID === action.payload.packageID);
                mempackages[packageIndexId] = memPackage;

                saveState(sessionKey1, memPackage);
                saveState(sessionKey2, membersnotpartofPackage);
            }

            saveState(sessionKey3, mempackages);

            return {
                ...state,
                loading: false,
                membershippackages: mempackages,
                membershipPackage: memPackage,
                familymembersnotpartofPackage: membersnotpartofPackage,
                membershippackagesError: ''
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerMembershipPackages;